/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'activity-center': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M480.608 91.43c-24.956-15.11-106.3-57.602-154.753-84.61-42.298-23.549-55.098 26.943-59.137 61.564s-4.026 79.55 40.324 79.55h162.752c44.35 0 44.35-35.897 10.75-56.504zM.052 267.035v101.746c0 37.627 12.542 56.57 62.789 56.57h371.12V216.04H61.937C11.058 215.911 0 232.608 0 266.984zm42.427 633.903C42.995 979.276 88.687 1024 186.339 1024h245.3V502.81H42.48s-.58 319.79 0 398.128zm981.539-629.541c0-34.363-14.98-55.422-65.808-55.422H592.353v209.272H961.1c50.234 0 62.906-17.278 62.906-54.97-.194-34.233-.13-64.634 0-98.88zM767.39 67.62c-4.039-34.556-16.904-85.164-59.202-61.563C659.775 33.065 578.404 75.622 553.5 90.796c-33.665 20.478-33.665 56.376 10.75 56.376h162.817c44.35 0 44.35-44.866 40.324-79.55zm-175.038 435.19V1024h237.75c97.59 0 141.565-49.034 142.082-127.346s-.13-393.844-.13-393.844zm0 0"/>'
  }
})
